/**
 * @generated SignedSource<<c54a803a3dd661c7afd3474bfb676478>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatChannelSideBarItemFragment$data = {
  readonly chatChannel: {
    readonly externalChannelId: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
  } | null;
  readonly customAppTitle: string | null;
  readonly id: string;
  readonly product: {
    readonly name: string;
    readonly slug: string;
    readonly viewerMembership: {
      readonly id: string;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"AppUtils_getLocationFragment" | "ChatChannelBadgeFragment" | "ChatChannelSettingsModalButtonFragment" | "DeleteChatChannelAppButtonFragment">;
  readonly " $fragmentType": "ChatChannelSideBarItemFragment";
};
export type ChatChannelSideBarItemFragment$key = {
  readonly " $data"?: ChatChannelSideBarItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelSideBarItemFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
],
v3 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatChannelSideBarItemFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customAppTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ChatChannel",
      "kind": "LinkedField",
      "name": "chatChannel",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "externalChannelId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "usePermissionsFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "product",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductMembership",
          "kind": "LinkedField",
          "name": "viewerMembership",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatChannelBadgeFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatChannelSettingsModalButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteChatChannelAppButtonFragment"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "AppUtils_getLocationFragment",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customAppUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "product",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Feed",
          "kind": "LinkedField",
          "name": "feed",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatChannel",
          "kind": "LinkedField",
          "name": "chatChannel",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Collection",
          "kind": "LinkedField",
          "name": "collection",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsage",
          "kind": "LinkedField",
          "name": "contentUsage",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "linkProduct",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "ProductApp",
  "abstractKey": null
};
})();

(node as any).hash = "aecc309fe143149ed5942fb0e934f9a4";

export default node;
